import { FPI, WEATHER_BRIEFING } from '@sdge-web-app/shared/dist/constants/paths';

const API_SERVER_URL = `${process.env.REACT_APP_API_SERVER_URL}/${process.env.REACT_APP_API_VERSION}`;
const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const ALL_FPI_DATA_ENDPOINT = `${API_SERVER_URL}/${FPI}`;
const WEATHER_BRIEFING_ENDPOINT = `${API_SERVER_URL}/${WEATHER_BRIEFING}/archive`;

export { ALL_FPI_DATA_ENDPOINT, WEATHER_BRIEFING_ENDPOINT, MAPBOX_ACCESS_TOKEN };
